// lodash
import get from 'lodash/get';
import find from 'lodash/find';

export function isFormMounted(form) {
  return form && !!find(form.registeredFields, ({ count }) => !!count);
}

export function getRegisteredFormFieldNames(form, mountedOnly = false) {
  const fields = get(form, 'registeredFields', {});

  if (mountedOnly) {
    return Object.keys(fields).reduce((acc, fieldName) => (
      fields[fieldName].count ? [...acc, fieldName] : acc
    ), []);
  }

  return Object.keys(fields).map(fieldName => fieldName);
}
